export { default as TextImageSection } from './TextImageSection';
export { default as AboutDescriptionSection } from './AboutDescriptionSection';
export { default as AboutQouteSection } from './AboutQouteSection';
export { default as FeatureSection } from './FeatureSection';
export { default as AboutQuoteSection } from './AboutQouteSection';
